import { render, staticRenderFns } from "./search-index.vue?vue&type=template&id=7ff39cde&scoped=true&"
import script from "./search-index.vue?vue&type=script&lang=js&"
export * from "./search-index.vue?vue&type=script&lang=js&"
import style0 from "./search-index.vue?vue&type=style&index=0&id=7ff39cde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff39cde",
  null
  
)

export default component.exports